import React from 'react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * HasPermission
 * Conditionally renders children if the authenticated user has the specified permissions.
 *
 * Props:
 * - permission: string (single required permission)
 * - anyOf: string[] (user must have at least one)
 * - allOf: string[] (user must have all)
 * - fallback: ReactNode (rendered when permission check fails, default null)
 * - children: ReactNode (rendered when permitted)
 */
export const HasPermission = ({
  permission,
  anyOf = [],
  allOf = [],
  fallback = null,
  children,
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = useAuth();

  let isAllowed = true;

  if (permission && !hasPermission(permission)) {
    isAllowed = false;
  }

  if (isAllowed && Array.isArray(anyOf) && anyOf.length > 0 && !hasAnyPermission(anyOf)) {
    isAllowed = false;
  }

  if (isAllowed && Array.isArray(allOf) && allOf.length > 0 && !hasAllPermissions(allOf)) {
    isAllowed = false;
  }

  if (!isAllowed) {
    return fallback;
  }

  return <>{children}</>;
};

export default HasPermission;

